<template>
	<div class="steps__step-form">
		<h3 class="h4 h4--b">
			Provide all available project specifics
		</h3>
		<p class="mb-24">
			All fields are required unless indicated as optional.
		</p>

		<form
			class="form form--fixed-fields"
			@submit.prevent="updateForm"
		>
			<InputComponent
				:value="form_fields.project_name"
				type="text"
				input-id="project-name"
				name="project-name"
				label="Project Name"
				sub-label="Number and client code will be added automatically"
				:required="true"
				:errors="form_errors.project_name || null"
				@update:value="new_value => form_fields.project_name = new_value"
			/>
			<InputComponent
				:value="form_fields.project_type"
				type="select"
				input-id="project-type"
				name="project-type"
				label="Project Type"
				:options="project_types"
				:required="true"
				:errors="form_errors.project_type || null"
				@update:value="new_value => form_fields.project_type = new_value"
			/>
			<InputComponent
				:value="form_fields.project_location"
				type="multilevel-dropdown"
				input-id="project-location"
				name="project-location"
				label="Project Location"
				placeholder="Search"
				:options="project_locations"
				:required="true"
				:errors="form_errors.project_location || null"
				@update:value="value => form_fields.project_location = value"
			/>
			<InputComponent
				:value="form_fields.project_coordinates"
				type="text"
				input-id="project-coordinates"
				name="project-coordinates"
				label="Project Coordinates"
				sub-label="Right-click in Google Maps and choose top option"
				:required="true"
				:errors="form_errors.project_coordinates || null"
				@update:value="new_value => form_fields.project_coordinates = new_value"
			/>
			<InputComponent
				:value="form_fields.intended_use"
				type="select"
				input-id="intended-use"
				name="intended-use"
				label="Intended Use"
				:options="intended_uses"
				:required="true"
				:errors="form_errors.intended_use || null"
				@update:value="new_value => form_fields.intended_use = new_value"
			/>
			<InputComponent
				:value="form_fields.kick_off"
				type="dateinputs"
				input-id="kick-off"
				name="kick-off"
				label="Kick off date"
				sub-label="DD / MM / YYYY"
				:required="true"
				:errors="form_errors.kick_off || null"
				@update:value="new_value => form_fields.kick_off = new_value"
			/>
			<InputComponent
				v-model="form_fields.completion_date"
				:value="form_fields.completion_date"
				type="dateinputs"
				input-id="completion-date"
				name="completion-date"
				label="Target completion date"
				sub-label="DD / MM / YYYY"
				:required="true"
				:errors="form_errors.completion_date || null"
				@update:value="new_value => form_fields.completion_date = new_value"
			/>
			<InputComponent
				:value="form_fields.project_description"
				type="textarea"
				input-id="project-description"
				name="project-description"
				label="Project Description"
				group-class="form__set--fixed-wide"
				char-limit="500"
				sub-label="Optional"
				:required="true"
				:errors="form_errors.project_description || null"
				@update:value="new_value => form_fields.project_description = new_value"
			/>
			<button
				class="button button--fill"
				type="submit"
			>
				Save {{ stepTitle }}
			</button>
		</form>
	</div>
</template>

<script setup>
import { useNewProjectStore } from '../../stores/new-project.js';
import { ref, defineProps, onMounted } from 'vue';
import { storeToRefs } from 'pinia';
import InputComponent from '../InputComponent';

const new_project_store = useNewProjectStore();
const { getProjectLocations, getProjectTypes, getIntendedUses, validateNewProjectStep } = new_project_store;
const {
	form_fields,
	form_errors,
	project_types,
	project_locations,
	intended_uses
} = storeToRefs( new_project_store );

defineProps( {
	stepTitle: {
		required: true,
		type: String,
		default: ''
	}
} );

const loading = ref( true );

onMounted ( async() => {
	await getProjectLocations();
	await getProjectTypes();
	await getIntendedUses();

	loading.value = false;
} );

async function updateForm() {
	validateNewProjectStep();
}

</script>
